/**
 * WORKFLOWPREVIEWSERVICE - PREVIEW DE WORKFLOWS
 *
 * Serviço para buscar workflows que seriam instalados baseado em agentId, tipo e filtros.
 * Útil para o frontend mostrar o que será instalado/executado antes de confirmar.
 */

import { get } from "@/shared/utils/fetchApi";

export interface WorkflowPreviewFilter {
  name: string;
  type: string;
  value: string;
}

export interface WorkflowPreviewItem {
  id: string;
  agent_id: string;
  agent_name: string;
  description?: string;
  type: string;
  content: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodes: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    edges: any[];
    workspaceId: string | null;
    organizationId: string | null;
  };
  filters: WorkflowPreviewFilter[];
  status: string;
  created_at: string;
  updated_at: string;
}

export interface WorkflowPreviewResponse {
  success: boolean;
  data: {
    agentId: string;
    type?: string;
    filtersApplied: WorkflowPreviewFilter[];
    totalWorkflows: number;
    workflows: WorkflowPreviewItem[];
  };
}

export class WorkflowPreviewService {
  private static readonly BASE_URL = "/workflows/preview";

  /**
   * Busca workflows preview baseado em agentId, tipo e filtros
   *
   * @param agentId ID do agente template
   * @param type Tipo de workflow (main, installer, setup, cleanup, custom)
   * @param filters Array de filtros para aplicar
   * @returns Lista de workflows que seriam instalados
   */
  static async getPreview(
    agentId: string,
    type?: string,
    filters?: WorkflowPreviewFilter[],
  ): Promise<WorkflowPreviewResponse> {
    const params = new URLSearchParams();
    params.append("agentId", agentId);

    if (type) {
      params.append("type", type);
    }

    if (filters && filters.length > 0) {
      params.append("filters", JSON.stringify(filters));
    }

    const qs = params.toString();

    return get<WorkflowPreviewResponse>(`${this.BASE_URL}?${qs}`);
  }
}
